import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-base" data-id="element-295" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-296" data-mp="cng1oereb36u">
        <div className="text-center mb-16" data-id="element-297" data-mp="cm52ytct4lml">
          <p className="text-accent font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-298" data-mp="7p65q1xujyk6">
            One system, seven complete volumes
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-extrabold mb-4 text-ink" data-id="element-299" data-mp="3g2vbbevv3arg">
            <span className="text-accent" data-id="element-300" data-mp="3c1jkj6194jho">7 complete volumes</span> in one system
          </h2>
          <p className="text-xl text-graphite" data-id="element-301" data-mp="3px42nz95oxo1">
            150 ready-to-coach sessions · Beginner to advanced · Nothing to build from scratch
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-302" data-mp="2xdfasrk6fib1">
          {volumes.map((volume, index) => <motion.div key={volume.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-paper rounded-2xl border ${volume.popular ? 'border-accent shadow-[0_14px_36px_-24px_rgba(138,14,24,0.6)]' : 'border-silver-light'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-303" data-mp="2sevmiki41ufi" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-35px] bg-accent text-white font-bold text-xs py-1 px-10 rotate-45" data-id="element-304" data-mp="1vg958cz9saaa">
                  START HERE
                </div>}
              <div className="mb-6 pr-16" data-id="element-305" data-mp="24h764meew1on">
                <div className="text-accent font-display font-bold text-sm uppercase tracking-widest" data-id="element-306" data-mp="3btzcttpllgoo">
                  {volume.number}
                </div>
                <h3 className="text-2xl font-display font-extrabold leading-tight mt-1 text-ink" data-id="element-307" data-mp="3ftzt7jw9c1yd">
                  {volume.title}
                </h3>
              </div>
              <p className="text-ink font-medium mb-6 border-l-2 border-accent pl-4" data-id="element-308" data-mp="1bsj10ink2vc9">
                {volume.subtitle}
              </p>
              <div className="mb-6" data-id="element-309" data-mp="1pqpr3cm9jr1d">
                <h4 className="text-sm font-bold text-graphite-light uppercase tracking-wider mb-2" data-id="element-310" data-mp="1ksnz226v0hdr">
                  What it solves in your coaching
                </h4>
                <p className="text-graphite text-sm leading-relaxed" data-id="element-311" data-mp="x0r03boidju2">{volume.problem}</p>
              </div>
              <h4 className="text-sm font-bold text-ink uppercase tracking-wider mb-3" data-id="element-312" data-mp="szf5ssuowafj">Inside</h4>
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2 mb-6 flex-grow" data-id="element-313" data-mp="16uhlg7pc9e5j">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2" data-id="element-314" data-mp="ebkbx94y400v">
                    <CheckCircle2 size={16} className="text-accent shrink-0 mt-0.5" aria-hidden="true" data-id="element-315" data-mp="9d904sv3bfg0" />
                    <span className="text-graphite text-sm" data-id="element-316" data-mp="2kyromg55gtah">{bullet}</span>
                  </li>)}
              </ul>
              {volume.sessions && <p className="text-sm font-display font-bold uppercase tracking-wider text-ink mb-6" data-id="element-317" data-mp="2c1hb0o4v0s2e">
                  {volume.sessions}
                </p>}
              <div className="bg-cream border border-silver-light rounded-xl p-4 mt-auto" data-id="element-318" data-mp="34pmyvjr7mx6g">
                <span className="text-accent font-display font-bold block mb-1 tracking-wider" data-id="element-319" data-mp="38qgpikw1eq31">
                  Result:
                </span>
                <p className="text-ink text-sm" data-id="element-320" data-mp="2usib5fhputnj">{volume.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}